var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex shipment-item-options"},[_c('div',{staticClass:"tw-flex tw-items-center shipment-item-options__pallets"},[_c('ui-ctk-icon',{attrs:{"name":"dimension"}}),(_vm.shipment.load.type === 'pallets')?_c('span',{domProps:{"textContent":_vm._s(_vm.$t('shipments.labels.pallets', {
        count: _vm.$n(_vm.shipment.load.quantity)
      }))}}):_c('span',{domProps:{"textContent":_vm._s(_vm.$t('shipments.labels.linear_meters', {
        linear_meters: _vm.$n(_vm.shipment.load.linear_meters)
      }))}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }